import script from "./AnalysisProductHub.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysisProductHub.vue?vue&type=script&setup=true&lang=js"

import "./AnalysisProductHub.vue?vue&type=style&index=0&id=5187c930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5187c930"]])

export default __exports__